declare global {
    interface Window {
        onYouTubeIframeAPIReady?: () => void;
    }
}

let youtubeLoaded = false;

function onYouTubeIframeAPIReady(): void {
    const event = document.createEvent('Event');
    event.initEvent('onYouTubeAPIReady', true, true);
    window.dispatchEvent(event);
}

function hasYouTubeIframeAPILoaded(): boolean {
    return youtubeLoaded;
}

function loadYouTubeIframeAPI(): Promise<void> {
    return new Promise((resolve, reject) => {
        window.addEventListener('onYouTubeAPIReady', () => {
            youtubeLoaded = true;
            resolve();
        });

        if (!window['YT']) {
            window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            const firstScriptParent = firstScriptTag.parentNode;
            if (firstScriptParent) {
                firstScriptParent.insertBefore(tag, firstScriptTag);
            } else {
                reject(new Error('Unable to insert SCRIPT tag, cannot find parent node.'));
            }
        } else {
            onYouTubeIframeAPIReady();
        }
    });
}

export { hasYouTubeIframeAPILoaded, loadYouTubeIframeAPI };
